var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-block"},[_c('font-awesome-icon',{staticClass:"has-text-danger",attrs:{"icon":['fas','long-arrow-alt-down'],"size":"1x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }